import { BaseEnvContribution } from "@visactor/vrender-core";

import { createCanvasWithFactory, getMiniAppCanvasOptions, wrapMiniAppContextCanvas } from "./miniapp-canvas";

const TARO_CANVAS_BRIDGE_ERROR = "Taro canvas bridge is unavailable. VRender taro env requires envParams.canvasFactory, a Stage canvas object, or envParams.taro.createCanvasContext(id).";

export class TaroEnvContribution extends BaseEnvContribution {
    constructor() {
        super(), this.type = "taro", this.supportEvent = !0, this.canvasMap = new Map, this.pixelRatio = 1, 
        this.taroEnvParams = {}, this.supportsTouchEvents = !0;
        try {
            this.supportsPointerEvents = !!globalThis.PointerEvent, this.supportsMouseEvents = !!globalThis.MouseEvent;
        } catch (err) {
            this.supportsPointerEvents = !1, this.supportsMouseEvents = !1;
        }
        this.applyStyles = !0;
    }
    getDynamicCanvasCount() {
        return 0;
    }
    getStaticCanvasCount() {
        return 9999;
    }
    mapToCanvasPoint(event) {
        var _a;
        return null === (_a = null == event ? void 0 : event.type) || void 0 === _a || _a.startsWith("mouse"), 
        event;
    }
    configure(service, params = {}) {
        var _a;
        service.env === this.type && (service.setActiveEnvContribution(this), this.taroEnvParams = params, 
        this.taro = params.taro, this.pixelRatio = null !== (_a = params.pixelRatio) && void 0 !== _a ? _a : 1);
    }
    loadImage(url) {
        return Promise.resolve({
            data: url,
            loadState: "success"
        });
    }
    loadSvg(svgStr) {
        const _window = "undefined" != typeof window ? window : globalThis;
        if (_window.DOMParser) {
            const svg = (new _window.DOMParser).parseFromString(svgStr, "image/svg+xml").children[0], data = (new XMLSerializer).serializeToString(svg), url = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(data)}`;
            return Promise.resolve({
                data: url,
                loadState: "success"
            });
        }
        if (_window.Blob) {
            const data = new _window.Blob([ svgStr ], {
                type: "image/svg+xml"
            }), url = _window.URL.createObjectURL(data);
            return Promise.resolve({
                data: url,
                loadState: "success"
            });
        }
        return Promise.reject();
    }
    createCanvas(params) {
        var _a, _b;
        const envParams = this.taroEnvParams, dpr = null !== (_a = params.dpr) && void 0 !== _a ? _a : this.getDevicePixelRatio(), factoryCanvas = createCanvasWithFactory(params, dpr, this.canvasMap, envParams.canvasFactory);
        if (factoryCanvas) return factoryCanvas;
        const options = getMiniAppCanvasOptions(params, dpr, !1);
        if (null == options.id || "function" != typeof (null === (_b = envParams.taro) || void 0 === _b ? void 0 : _b.createCanvasContext)) throw new Error(TARO_CANVAS_BRIDGE_ERROR);
        const canvas = wrapMiniAppContextCanvas(envParams.taro.createCanvasContext(options.id), options);
        return this.canvasMap.set(options.id, canvas), canvas;
    }
    createOffscreenCanvas(params) {}
    releaseCanvas(canvas) {}
    getDevicePixelRatio() {
        return this.pixelRatio;
    }
    getRequestAnimationFrame() {
        return requestAnimationFrame;
    }
    getCancelAnimationFrame() {
        return cancelAnimationFrame;
    }
    addEventListener(type, listener, options) {
        return null;
    }
    removeEventListener(type, listener, options) {
        return null;
    }
    dispatchEvent(event) {
        return null;
    }
    getElementById(str) {
        return this.canvasMap.get(str);
    }
    getRootElement() {
        return null;
    }
    getDocument() {
        return null;
    }
    release(...params) {}
}
//# sourceMappingURL=taro-contribution.js.map
